'use strict';
namespace TR {
    export class FlightsFilterService {
        constructor(
            private $filter: angular.IFilterService) {
        }

        private sortArray = (arr, prop) => {
            var sortBy = '-count';
            if(prop === 'FlightsByAirline' && TRPCONFIG.Domain.FlightsByAirlineFilterOrder) {
                sortBy = TRPCONFIG.Domain.FlightsByAirlineFilterOrder;
            }
            if(prop === 'DepartureDates') {
                sortBy = 'name';
            }
            return this.$filter('orderBy')(arr, sortBy);
        }

        arrayifyAggregates = (dict, props) :void => {
            for (var i = 0; i < props.length; i++) {
                var prop = props[i];
                if (dict[prop + 'Array']) {
                    continue;
                }
                var arr:any = [];
                for (var p in dict[prop]) {
                    if (dict[prop].hasOwnProperty(p)) {
                        arr.push({
                            name: p,
                            count: dict[prop][p].Count != null ? dict[prop][p].Count : dict[prop][p],
                            logo: dict[prop][p].Logo,
                            minimumPrice: dict[prop][p].MinimumPrice
                        });
                    }
                }
                dict[prop + 'Array'] = this.sortArray(arr, prop);
            }
        }

        populateMinimumPrice  = (dict) :void => {
            const values = _.values(dict.FlightsByAirline);
            dict.minimumPrice = (_.minBy(values, (x: any) => x.MinimumPrice) || {}).MinimumPrice;
        }
    }

    angular.module('TR').service('flightsFilterService', FlightsFilterService);
}
